import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "92vw",
  boxSizing: "border-box",
  bgcolor: "background.paper",
  border: 0,
  borderRadius: "18px",
  boxShadow: "0 32px 64px -20px rgba(15,27,42,0.5)",
  p: "28px 24px 22px",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.5,
  outline: "none",
  fontFamily: FONT,
};

export default function ErrorModal({
  open,
  handleClose,
  msg,
  type = "error", // 🔥 important
}) {
  const isSuccess = type === "success";

  return (
    <Modal
      open={open}
      onClose={handleClose}
      slotProps={{ backdrop: { sx: { background: "rgba(15,27,42,0.46)" } } }}
    >
      <Box sx={style}>
        
        {/* ICON */}
        <div
          style={{
            background: isSuccess ? "#E9F7EE" : "#FBEDEB",
            border: `1px solid ${isSuccess ? "#C4E8D2" : "#F2CFCA"}`,
            borderRadius: "50%",
            width: "64px",
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <div
            style={{
              background: isSuccess ? "#2FA864" : "#E0564A",
              borderRadius: "50%",
              width: "44px",
              height: "44px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isSuccess ? (
              <CheckCircleIcon sx={{ width: "26px", height: "26px", color: "#fff" }} />
            ) : (
              <ClearIcon sx={{ width: "26px", height: "26px", color: "#fff" }} />
            )}
          </div>
        </div>

        {/* TITLE */}
        <Typography
          variant="h6"
          sx={{ fontFamily: FONT, fontSize: 18, fontWeight: 800, letterSpacing: "-0.02em", color: "#0F1B2A" }}
        >
          {isSuccess ? "Success" : "Something Went Wrong"}
        </Typography>

        {/* MESSAGE */}
        <Typography
          variant="body1"
          sx={{ fontFamily: FONT, fontSize: 14, lineHeight: 1.5, color: "#4A5A6E", textWrap: "pretty", mb: 1 }}
        >
          {msg || (isSuccess ? "Operation completed successfully" : "Please try again")}
        </Typography>

        {/* BUTTON */}
        <Button
          fullWidth
          onClick={handleClose}
          sx={{
            height: 44,
            borderRadius: "10px",
            background: isSuccess ? "#1B6B41 !important" : "#0F1B2A !important",
            color: "#fff",
            fontFamily: FONT,
            fontSize: 14,
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": { opacity: 0.92 },
          }}
        >
          OK
        </Button>
      </Box>
    </Modal>
  );
}
